export default "__VITE_PUBLIC_ASSET__34fa437e__"